import React from 'react';

import programTypeStatuses from 'data/program_type_statuses';

import CellStringItemWithTooltip from 'components/ui/Table/CellStringItemWithTooltip';
import Actions from './Actions';

const programTypeStatus = (value) => (
  programTypeStatuses.find((status) => status.value === value)
);

const columns = ({ enterpriseId, onClose }) => [
  ...(enterpriseId ? [] : [{
    name: 'Enterprise',
    selector: (row) => row.attributes.enterprise,
    sortable: true,
    maxWidth: '240px',
  }]),
  {
    name: 'Program Name',
    selector: (row) => row.attributes.title,
    sortable: true,
    cell: (row) => <CellStringItemWithTooltip text={row.attributes.title} />,
    maxWidth: enterpriseId ? '480px' : '240px',
  },
  {
    name: 'Type',
    selector: (row) => row.attributes.type,
    cell: (row) => programTypeStatus(row.attributes.type)?.label,
    sortable: true,
    width: '100px',
  },
  {
    name: 'Sessions',
    selector: (row) => row.attributes.sessions,
    cell: (row) => (row.attributes.type === 'cpa' ? 'N/A' : row.attributes.sessions),
    sortable: true,
    width: '100px',
  },
  {
    name: 'Assigned',
    selector: (row) => row.attributes.statistics.assigned,
    sortable: true,
    width: '100px',
  },
  {
    name: 'In Progress',
    selector: (row) => (row.attributes.type === 'cpa' ? 0 : row.attributes.statistics.in_progress),
    cell: (row) => row.attributes.statistics.in_progress,
    sortable: true,
    width: '100px',
  },
  {
    name: 'Completed',
    selector: (row) => row.attributes.statistics.completed,
    sortable: true,
    width: '100px',
  },
  {
    name: 'Actions',
    sortable: false,
    width: '100px',
    right: true,
    cell: (row) => <Actions row={row} onClose={onClose} />,
  },
];

export default columns;
